import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(initReactI18next).use(LanguageDetector).init({
    debug: true,
   // fallbackLng: 'en',
    resources: {
        en : { 
            translation : {
                headerTitle : 'Rhine temperature Basel',
                currentValue: 'current',
                minValue: "min (24h)",
                maxValue: "max (24h)",
                lastUpdated: "refreshed on",
                outflow: "outflow",
                level: "level",
                titleWaterCurrent : "Water temperature",
                titleAirCurrent : "Air temperature",
                titleWaterHistory :'Water temperature last 7 days',
                titleAirHistory : 'Air temperature last 7 days',
                titleWaterflow: "Water flow"
            }
        },
        de : {
            translation : {
                headerTitle : 'Rheintemperatur Basel',
                currentValue: 'Aktuell',
                minValue: "Minimum (24h)",
                maxValue: "Maximum (24h)",
                lastUpdated: "Aktualisiert",
                outflow: "Abflussmenge",
                level: "Pegel",
                titleWaterCurrent : "Wassertemperatur",
                titleAirCurrent : "Lufttemperatur",
                titleWaterHistory : "Wassertemperatur letzte 7 Tage",
                titleAirHistory : "Lufttemperatur letzte 7 Tage",
                titleWaterflow: "Wasserfluss" 
            }
        }
    }, // Where we're gonna put translations' files
    //language: i18n.language

});
i18n.languages = ['en', 'de'];

export default i18n;